import PrimaryButton from '../components/PrimaryButton/PrimaryButton';
import { Dialog, DialogContent } from '../components/Dialog';

interface Props {
  isShow: boolean;
  onHide: () => void;
  onOkay?: () => void;
}

const CheckinLimitModal = ({ isShow, onHide, onOkay }: Props): JSX.Element => {
  const handleOkay = () => {
    onOkay?.();
    onHide();
  };

  return (
    <Dialog
      open={isShow}
      onOpenChange={(isOpen) => {
        if (!isOpen) {
          onHide();
        }
      }}
    >
      <DialogContent
        className='w-[min(95vw,540px)] rounded-[0.6rem] border-0 bg-white p-0 text-[1.6rem] shadow-[0_14px_34px_rgba(0,0,0,0.2)]'
        overlayClassName='bg-black/50'
      >
        <div className='relative px-[2.6rem] pb-[1.6rem] pt-[2.8rem]'>
          <button
            type='button'
            onClick={onHide}
            aria-label='Close'
            className='absolute right-[1rem] top-[0.7rem] border-0 bg-transparent p-0 text-[2.4rem] leading-none text-[#242424]'
          >
            x
          </button>
          <h2 className="m-0 text-center font-['GT-Walsheim-Pro-Bold'] text-[3rem] leading-[1.2] text-[#242424]">
            You’ve Checked In for Now 💙
          </h2>
        </div>

        <div className='mx-[2.6rem] mb-[2.6rem] mt-[0.4rem] flex flex-col gap-[2.4rem]'>
          <p className="m-0 font-['GT-Walsheim-Pro-Light'] text-[1.8rem] leading-[1.5] text-[#3f3f3f]">
            Thanks for sharing how you’re feeling. To keep check-ins meaningful, you can submit up to{' '}
            <b>3 feelings check-ins per hour.</b>
            <br />
            <br />
            You’re welcome to pause, try one of the activities, or come back later to check in again.
          </p>

          <div className='flex justify-center'>
            <PrimaryButton onClick={handleOkay}>Got it</PrimaryButton>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default CheckinLimitModal;
